import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TextChatActionsComponent } from './text-chat-actions.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild()
  ],
  declarations: [
    TextChatActionsComponent
  ],
  exports: [
    TextChatActionsComponent
  ]
})
export class TextChatActionsModule {}
